

import React from "react";
import {Jumbotron} from "reactstrap";

const List = () => {
    return(
        <div>
            <br/><br/>
       <h3 style={{ fontFamily: "Comfortaa", color: "black" }}>Patented cutting edge technology</h3>
       <h5 style={{ fontFamily: "Comfortaa", color: "black" }}><i>backed by decades of experience in construction</i></h5>    
    <Jumbotron className="jumbobg">
        <div></div>
      </Jumbotron>
      </div>
      );
        
    
}

export default List;